module.exports = __webpack_public_path__ + "3d764f93f2bee9c8cb17715330e9d1ad.pdf";